import { themes } from 'kb-shared';
import styled from 'styled-components';

const { queries } = themes;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  padding: 45px 45px 30px 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: ${themes.colors.white};
  border-left: 8px solid ${themes.colors.yellow.primary};

  @media ${queries.minDesktop} {
    padding: 45px 45px 20px 24px;
    min-width: 500px;
  }
`;

export const Body = styled.div`
  margin-left: 51px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  font-size: 16px;
`;

export const PhoneNumberSmall = styled.a`
  color: ${({ theme }) => theme.colors.blue.darkBlue};
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
`;
